import React from 'react';

import './separatorComponent.css';

const SeparatorComponent = ({isSmall = false}) => {
  return (
    <div
      className={`et-n-separator-component-container ${isSmall ? 'et-n-scc-small-container' : ''}`}
    />
  );
};

export default SeparatorComponent;
